import { buildHeaders } from "src/utils/apiUtils";


let BASE_URL = process.env.REACT_APP_API_URL

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

loadConfig().then(() => {
});


export async function fetchAllDataApi(url: string, options: RequestInit = {}): Promise<any> {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/${url}`, {
        ...options,
        headers,
        credentials: "include"
      });
  
      
  
      const data = await response.json();
      
      //////console.log("Response Data:", data);
  
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
       
        //toast(data.message || "Failed to fetch");
      }
  
      return data;
    } catch (error: any) {
      ////console.error("Fetch Error:", error);
      //console.log(error.message || "Failed to fetch");
    }
  }

  export async function getLatestMessages(url: string, options: RequestInit = {}): Promise<any> {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/${url}`, {
        ...options,
        headers,
        credentials: "include",
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
          }
  
      return data;
    } catch (error: any) {
      ////console.error("Fetch Error:", error);
      //console.log(error.message || "Failed to fetch");
    }
  }

  export async function fetchAllNotifications(perPage: number, pageNo: number, search: string): Promise<any> {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/notifications/compliance-notifications?search=${search}&perPage=${perPage}&pageNo=${pageNo}`, {
        headers,
        credentials: "include",
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
          }
  
      return data;
    } catch (error: any) {
      ////console.error("Fetch Error:", error);
      //console.log(error.message || "Failed to fetch");
    }
  }


  export async function getUnseenNotifications(): Promise<any> {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/notifications/compliance-notifications-unseen`, {
        headers,
        credentials: "include",
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
      }
  
      return data;
    } catch (error: any) {
      //console.log(error.message || "Failed to fetch unseen notifications");
    }
  }

  export async function seenNotification(): Promise<any> {
    try {
      const headers = await buildHeaders(BASE_URL);
      const response = await fetch(`${BASE_URL}/notifications/seen`, {
        method: 'PATCH',
        headers,
        credentials: "include",
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
      }
  
      return data;
    } catch (error: any) {
      //console.log(error.message || "Failed to mark notifications as seen");
    }
  }